import { render, staticRenderFns } from "./personAudit.vue?vue&type=template&id=27742fae&scoped=true&"
import script from "./personAudit.vue?vue&type=script&lang=js&"
export * from "./personAudit.vue?vue&type=script&lang=js&"
import style0 from "./personAudit.vue?vue&type=style&index=0&id=27742fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27742fae",
  null
  
)

component.options.__file = "personAudit.vue"
export default component.exports